import { Box, Button } from "@mui/material";
import { useIntl } from "react-intl";
import useGlobalContext from "hooks/globalData";
import { useEffect, useState } from "react";
import {
  DEFAULT_ROWS_PER_PAGE,
  TableCellType,
  TableSortType,
  LazyTable,
  RoundedBox,
} from "@knowfully/ui.common";
import {
  CatalogFilter,
  HomeStudyCourseModel,
  ListRequestOfCatalogFilter,
} from "services/organizationPortalClient";
import { useQuery } from "react-query";
import HomeStudyCatalogFilter from "./HomeStudyCatalogFilter";
import AddIcon from "@mui/icons-material/Add";
import CreditsCell from "pages/CourseCatalog/CreditsCell";
import { CourseTitleCell } from "components/CourseTitleCell/CourseTitleCell";
import { Link } from "react-router-dom";
import contextStore from "stores/contextStore";

export default function HomeStudyTab() {
  const { formatMessage: t } = useIntl();
  const { catalogService, courseDetailsEnrollUsersUrl } = useGlobalContext();
  const [order, setOrder] = useState<TableSortType>("desc");
  const [orderBy, setOrderBy] = useState("releaseDate");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(DEFAULT_ROWS_PER_PAGE);
  const [filter, setFilter] = useState({} as CatalogFilter);
  const { organization } = contextStore.useState();

  const { data, isFetching } = useQuery(
    [
      "getHomeStudyCourses",
      organization?.id,
      order,
      orderBy,
      page,
      rowsPerPage,
      filter,
    ],
    () =>
      catalogService.getHomeStudyCourses(
        ListRequestOfCatalogFilter.fromJS({
          pageNumber: page,
          pageSize: rowsPerPage,
          sortField: orderBy,
          sortDescending: order === "desc",
          parameters: filter,
        })
      ),
    { keepPreviousData: true }
  );

  useEffect(() => {
    setPage(0);
  }, [filter]);

  const cells: Array<TableCellType> = [
    {
      accessor: "title",
      type: "node",
      label: t({ id: "title" }),
      View: ({ value }: { value: HomeStudyCourseModel }) => (
        <CourseTitleCell skuId={value.id} title={value.title} />
      ),
    },
    {
      accessor: "releaseDate",
      type: "date",
      label: t({ id: "releaseDate" }),
    },
    {
      accessor: "credits",
      type: "node",
      label: t({ id: "credits" }),
      View: CreditsCell,
    },
    {
      accessor: "format",
      type: "text",
      label: t({ id: "format" }),
    },
    {
      accessor: "instructor",
      type: "text",
      label: t({ id: "instructor" }),
      noSort: true,
    },
    {
      accessor: "",
      type: "node",
      label: "",
      View: ({ value }: { value: HomeStudyCourseModel }) => (
        <Link to={courseDetailsEnrollUsersUrl(value.id)}>
          <Button startIcon={<AddIcon />}>{t({ id: "register" })}</Button>
        </Link>
      ),
    },
  ];

  return (
    <Box>
      <RoundedBox>
        <HomeStudyCatalogFilter onChange={setFilter} />
      </RoundedBox>
      <RoundedBox>
        <LazyTable
          {...{
            "aria-label": t({ id: "homeStudyCatalog" }),
            loading: isFetching,
            rowCount: data?.totalRecords ?? 0,
            rows: data?.data ?? [],
            cells,
            page,
            setPage,
            order,
            setOrder,
            orderBy,
            setOrderBy,
            rowsPerPage,
            setRowsPerPage,
          }}
        />
      </RoundedBox>
    </Box>
  );
}
